// dependencies imports ⇒
import React, { useState } from "react";
// assets and scss imports ⇒
import "./abhaAddressListView.scss";
// project file imports(UI components) ⇒
import PrimaryButton from "../../../common/Buttons/PrimaryButton";

const AbhaAddressListView = (props) => {
  // const declarations ⇒

  const {
    mobileNumber,
    abhaAddressList,
    handleSelectAbhaAddress,
    handleAddListContinue,
  } = props;

  // create UI ⇒

  const patientAbhaAddressListHeaderAndSubheader = () => {
    let mobileNo = mobileNumber ? "******" + mobileNumber.substring(6, 10) : "";
    return (
      <div className="aalv-content-heading-container">
        <p className="aalv-content-heading">Choose your ABHA Address</p>
        <p className="aalv-content-subheading">
          You have {abhaAddressList?.length} ABHA Address link with this mobile
          number {mobileNo}
        </p>
      </div>
    );
  };

  const patientAbhaAddressListUI = () => {
    return (
      <div className="aalv-abha-address-list-container">
        {abhaAddressList.map((abha_item, index) =>
          patientAbhaAddressCard(abha_item, index)
        )}
      </div>
    );
  };

  const patientAbhaAddressCard = (abha_details, index) => {
    return (
      <div
        className={
          "aalv-abha-address-card " +
          (abha_details?.selected ? "aalv-abha-address-card-selected" : "")
        }
        key={index}
        onClick={() => handleSelectAbhaAddress(abha_details)}
      >
        <p className="aalv-card-content">
          {abha_details?.preferredAbhaAddress}
        </p>
        {abha_details?.selected && <div className="aalv-check-icon" />}
      </div>
    );
  };

  const mobileNumberContinueBtn = () => {
    let disabledContinue =
      abhaAddressList.filter((data) => data.selected)?.length === 0;
    return (
      <div className="mnvc-continue-btn-wrapper">
        <PrimaryButton
          title="Continue"
          disabled={disabledContinue}
          handleButtonClick={handleAddListContinue}
        />
      </div>
    );
  };

  const patientAbhaAddressListContent = () => {
    return (
      <>
        {patientAbhaAddressListHeaderAndSubheader()}
        {patientAbhaAddressListUI()}
        {mobileNumberContinueBtn()}
      </>
    );
  };

  return (
    <div className="abha-address-list-view">
      {patientAbhaAddressListContent()}
    </div>
  );
};

// export ⇒

export default AbhaAddressListView;
